/** `data-app-id` da troca de cartão 2026 — prefixo `card-change-` (mesmo padrão de `renewalAppIds.ts`). */
export const CARD_CHANGE_APP_IDS = {
  screen: 'card-change-screen',
  loading: 'card-change-loading',
  loadError: 'card-change-load-error',
  loadMissing: 'card-change-load-missing',
  loadErrorSupport: 'card-change-load-error-support',
  supportDrawer: 'card-change-support-drawer',
  stepSummary: 'card-change-step-summary',
  contractSummary: 'card-change-contract-summary',
  startChange: 'card-change-start',
  summarySupport: 'card-change-summary-support',
  stepForm: 'card-change-step-form',
  paymentMethod: 'card-change-payment-method',
  newCard: 'card-change-new-card',
  processing: 'card-change-processing',
  outcome: 'card-change-outcome'
} as const;
